import React from 'react';
import { Helmet } from 'react-helmet';

const TechScreenView = () => (
  <>
    <Helmet>
      <title>Tech Screen</title>
    </Helmet>
    <h1>Tech Screen Placeholder</h1>
  </>
);

export default TechScreenView;
